// https://github.com/parcel-bundler/parcel/issues/1762#issuecomment-519631755
import 'regenerator-runtime/runtime';
import { main } from './main';

main();
